// import React from "react";
// import Select, { components } from "react-select";
// import Animated from "react-select/animated";

// import FilterIcon from "../../assets/images/app/allaya/filter-autocomplete.svg";

// let styles = {
//     container: (provided) => ({
//         ...provided,
//         display: "inline-block",
//         position: "relative",
//         width: "100%"
//     }),
//     control: (provided, state) => ({
//         ...provided,
//         borderRadius: "4px",
//         border: "1px solid #ebebeb",
//         borderColor: "#ebebeb",
//         background: "#fff",
//         boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.04)",
//         height: "36px",

//         "&:hover": {
//             borderColor: "#ebebeb"
//         }
//     })
// };

// const Filter = () => {
//     return (
//         <svg
//             width="17"
//             height="12"
//             viewBox="0 0 17 12"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//         >
//             <path
//                 d="M10.8657 0C11.3345 0 11.7407 0.40625 11.7407 0.875C11.7407 1.09375 11.647 1.28125 11.522 1.4375L8.24072 5.1875V11.25C8.24072 11.6875 7.89697 12 7.45947 12C7.30322 12 7.14697 11.9688 6.99072 11.875L4.61572 10.0625C4.36572 9.875 4.24072 9.59375 4.24072 9.25V5.1875L0.928223 1.4375C0.803223 1.28125 0.740723 1.09375 0.740723 0.875C0.740723 0.40625 1.11572 0 1.58447 0H10.8657ZM5.24072 5V9.25L7.24072 10.7812V5C7.24072 4.90625 7.27197 4.78125 7.33447 4.6875L10.5532 1H1.89697L5.11572 4.6875C5.17822 4.78125 5.20947 4.90625 5.20947 5H5.24072ZM16.2407 10.5C16.4907 10.5 16.7407 10.75 16.7407 11C16.7407 11.2812 16.4907 11.5 16.2407 11.5H11.2407C10.9595 11.5 10.7407 11.2812 10.7407 11C10.7407 10.75 10.9595 10.5 11.2407 10.5H16.2407ZM10.7407 6C10.7407 5.75 10.9595 5.5 11.2407 5.5H16.2407C16.4907 5.5 16.7407 5.75 16.7407 6C16.7407 6.28125 16.4907 6.5 16.2407 6.5H11.2407C10.9595 6.5 10.7407 6.28125 10.7407 6ZM16.2407 0.5C16.4907 0.5 16.7407 0.75 16.7407 1C16.7407 1.28125 16.4907 1.5 16.2407 1.5H13.2407C12.9595 1.5 12.7407 1.28125 12.7407 1C12.7407 0.75 12.9595 0.5 13.2407 0.5H16.2407Z"
//                 fill="#8A8989"
//             />
//         </svg>
//     );
// };

// const DropdownIndicator = (props) => {
//     return (
//         components.DropdownIndicator && (
//             <components.DropdownIndicator {...props}>
//                 <Filter />
//             </components.DropdownIndicator>
//         )
//     );
// };

// const AutoComplete = ({
//     className = "",
//     options,
//     onInputChange = () => {},
//     onChange,
//     handleBlur = () => {},
//     customStyles = undefined,
//     maxMenuHeight,
//     isClearable = false,
//     placeholder = "",
//     isLoading = false,
//     value,
//     isMulti = false,
//     handleScroll = undefined,
//     handleOnFocus = undefined,
//     selectRef,
//     isOptionDisabled = undefined,
//     isDisabled,
//     closeMenuOnSelect = true,
//     label = "",
//     classNamePrefix = "",
//     ...rest
// }) => {
//     styles = customStyles ? customStyles : styles;
//     return (
//         <div>
//             {label && <p className="input-label fw-bold mb-2">{label}</p>}
//             <Select
//                 isDisabled={isDisabled}
//                 onFocus={handleOnFocus}
//                 onBlur={handleBlur}
//                 ref={selectRef}
//                 onMenuScrollToBottom={handleScroll}
//                 className={className}
//                 options={options}
//                 onInputChange={onInputChange}
//                 onChange={onChange}
//                 styles={styles}
//                 maxMenuHeight={maxMenuHeight}
//                 isClearable={isClearable}
//                 placeholder={placeholder}
//                 closeMenuOnSelect={closeMenuOnSelect}
//                 isLoading={isLoading}
//                 value={value}
//                 isOptionDisabled={isOptionDisabled}
//                 isMulti={isMulti}
//                 // components={Animated()}
//                 components={{ IndicatorSeparator: () => null, DropdownIndicator }}
//                 classNamePrefix={classNamePrefix}
//                 {...rest}
//             />
//         </div>
//     );
// };

// export default AutoComplete;

import React from "react";
import Select, { components } from "react-select";
import makeAnimated from "react-select/animated";
import Animated from "react-select/animated";

// import FilterIcon from "../../assets/images/app/allaya/filter-autocomplete.svg";
import { ReactComponent as FilterIcon } from "../../assets/images/app/allaya/filter-autocomplete.svg";

// Define default styles
const defaultStyles = {
    container: (provided) => ({
        ...provided,
        display: "inline-block",
        position: "relative",
        width: "100%"
    }),
    control: (provided, state) => ({
        ...provided,
        borderRadius: "4px",
        border: "1px solid #ebebeb",
        background: "#fff",
        boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.04)",
        height: "36px",
        "&:hover": {
            borderColor: "#ebebeb"
        }
    })
};

const DropdownIndicator = (props) =>
    components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            <FilterIcon />
        </components.DropdownIndicator>
    );

const AutoComplete = ({
    className = "",
    options,
    onInputChange = () => {},
    onChange,
    handleBlur = () => {},
    customStyles,
    maxMenuHeight,
    isClearable = false,
    placeholder = "",
    isLoading = false,
    value,
    isMulti = false,
    handleScroll,
    handleOnFocus,
    selectRef,
    isOptionDisabled,
    isDisabled,
    closeMenuOnSelect = true,
    label = "",
    classNamePrefix = "",
    ...rest
}) => {
    const combinedStyles = customStyles || defaultStyles;

    return (
        <div>
            {label && <p className="input-label ">{label}</p>}
            <Select
                isDisabled={isDisabled}
                onFocus={handleOnFocus}
                onBlur={handleBlur}
                ref={selectRef}
                onMenuScrollToBottom={handleScroll}
                className={className}
                options={options}
                onInputChange={onInputChange}
                onChange={onChange}
                styles={combinedStyles}
                maxMenuHeight={maxMenuHeight}
                isClearable={isClearable}
                placeholder={placeholder}
                closeMenuOnSelect={closeMenuOnSelect}
                isLoading={isLoading}
                value={value}
                isOptionDisabled={isOptionDisabled}
                isMulti={isMulti}
                components={Animated()}
                // components={{
                //     ...animatedComponents,
                //     IndicatorSeparator: () => null,
                //     DropdownIndicator
                // }}
                classNamePrefix={classNamePrefix}
                {...rest}
            />
        </div>
    );
};

export default AutoComplete;
